import React, { ReactNode } from "react";
import clsx from "clsx";
import styles from "./dashboard-portlet.css";

const {
  container: containerClassName,
  content: contentClass,
  header: headerClassName,
  body: bodyClass,
} = styles;

export type DashboardPortletProps = {
  className?: string;
  contentClassName?: string;
  bodyClassName?: string;
  header?: ReactNode;
  body: ReactNode;
};

export const DashboardPortlet = ({
  className,
  header,
  body,
  contentClassName,
  bodyClassName,
}: DashboardPortletProps) => {
  return (
    <div className={clsx(containerClassName, className)}>
      <div className={clsx(contentClass, contentClassName)}>
        {header && <div className={headerClassName}>{header}</div>}
        <div id="scrollable-div" className={clsx(bodyClass, bodyClassName)}>
          {body}
        </div>
      </div>
    </div>
  );
};
